module.exports = __webpack_public_path__ + "img/emw_2.bdffbb66.png";